/**
 * The distribution of pricing days.
 * tag: 41214
 * @readonly
 * @enum {number} (int)
 */
export enum PaymentStreamPricingDayDistribution {
  /** All */
  All = 0,
  /** First */
  First = 1,
  /** Last */
  Last = 2,
  /** Penultimate */
  Penultimate = 3,
}
